import { ImageWithFallback } from '@fdc/components/ui/image-with-fallback/image-with-fallback';
import { FeatureTagZone } from '@woolworthslimited/core-components-react/tag-zone/tag-zone';
import { RoundelProps } from '@woolworthslimited/core-components-react/tag-zone/tag-zone.types';
import clsx from 'clsx';
import Link from 'next/link';

import styles from './cart-product-image.module.scss';

interface CartProductImageProps {
  productImageUrl: string;
  fallbackImgSrc: string;
  description: string;
  tagZone: { roundel?: RoundelProps[] };
  isRestricted?: boolean;
  href: string;
  persistentRoundel?: boolean;
}

export const CartProductImage = ({
  productImageUrl,
  fallbackImgSrc,
  description,
  tagZone,
  isRestricted,
  href,
  persistentRoundel = false,
}: CartProductImageProps) => (
  <div className={styles.productImageContainer} role="presentation">
    <Link
      href={href}
      prefetch={false}
      aria-label={description}
      className={clsx(styles.productImage, {
        [styles.productImageWithRoundel]:
          !!tagZone?.roundel && !persistentRoundel,
        [styles.productImageWithRoundelPersistent]:
          !!tagZone?.roundel && persistentRoundel,
      })}
    >
      <ImageWithFallback
        loading="lazy"
        src={productImageUrl}
        fallbackSrc={fallbackImgSrc}
        isBlankFallback={isRestricted}
        alt={description}
      />
    </Link>
    {!isRestricted && tagZone.roundel && (
      <FeatureTagZone
        type="roundel"
        customStyles={styles.roundelImageUrl}
        maxTagsToShow={1}
        model={tagZone.roundel}
      />
    )}
  </div>
);
